import React from 'react';
import { FiX, FiAlertTriangle } from 'react-icons/fi';

export function VoidInvoiceModal({ 
  isOpen, 
  invoice, 
  voidReason, 
  setVoidReason, 
  onVoid, 
  onClose 
}) {
  if (!isOpen || !invoice) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-gray-900 flex items-center">
            <FiAlertTriangle className="mr-2 text-red-500" />
            Void Invoice
          </h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
          >
            <FiX size={20} />
          </button>
        </div>
        <p className="text-gray-600 mb-4">
          Are you sure you want to void invoice <strong>{invoice.invoiceNumber}</strong>? This action cannot be undone.
        </p>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Reason for voiding (optional)
          </label>
          <textarea
            value={voidReason}
            onChange={(e) => setVoidReason(e.target.value)}
            className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm"
            rows="3"
            placeholder="Enter reason for voiding this invoice..."
          />
        </div>
        <div className="flex justify-end space-x-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200"
          >
            Cancel
          </button>
          <button
            onClick={onVoid}
            className="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-md hover:bg-red-700"
          >
            Void Invoice
          </button>
        </div>
      </div>
    </div>
  );
}

export function SupersedeInvoiceModal({ 
  isOpen, 
  invoice, 
  supersedeReason, 
  setSupersedeReason, 
  onSupersede, 
  onClose 
}) {
  if (!isOpen || !invoice) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-gray-900 flex items-center">
            <FiAlertTriangle className="mr-2 text-yellow-500" />
            Supersede Invoice
          </h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
          >
            <FiX size={20} />
          </button>
        </div>
        <p className="text-gray-600 mb-4">
          Mark invoice <strong>{invoice.invoiceNumber}</strong> as superseded. This indicates it has been replaced by a new invoice.
        </p>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Reason for superseding (optional)
          </label>
          <textarea
            value={supersedeReason}
            onChange={(e) => setSupersedeReason(e.target.value)}
            className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm"
            rows="3"
            placeholder="Enter reason for superseding this invoice..."
          />
        </div>
        <div className="flex justify-end space-x-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200"
          >
            Cancel
          </button>
          <button
            onClick={onSupersede}
            className="px-4 py-2 text-sm font-medium text-white bg-yellow-600 rounded-md hover:bg-yellow-700"
          >
            Supersede Invoice
          </button>
        </div>
      </div>
    </div>
  );
}
